import { BaseService } from 'core/services';
import { LoginRouteService } from 'common/data';

class LoginService extends BaseService {
	constructor(apiClient, tokenHandler) {
		super(apiClient, new LoginRouteService());
		this.tokenHandler = tokenHandler;
	}

	login = async data => {
		let settings = {};
		if (data.options) {
			settings.options = data.options;
		}
		const url = this.routeService.login(settings);
		const response = await this.apiClient.post(
			url,
			this.transformData({
				grant_type: 'password',
				username: data.username,
				password: data.password,
				organization: data.organization,
			}),
			{
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			}
		);
		this.tokenHandler.store(response.data.accessToken);
		return response;
	};

	transformData = data => {
		let items = [];
		for (let key in data) {
			items.push([encodeURIComponent(key), encodeURIComponent(data[key])].join('='));
		}
		return items.join('&');
	};
}

export default LoginService;
